<template>
  <div v-if="transaction">
    <div class="">

      <div class="p-2 p-sm-3">
        <div class="w-100 text-center">
          <h2 class="mb-1">
            <b-badge :variant="statusVariant(transaction.data.status)">
              {{ statusName(transaction.data.status) }}
            </b-badge>
          </h2>

          <h3 class="mb-4">{{ transaction.data.status_message }}</h3>

          <p><b>Monto:</b> {{ payment.amount }}</p>
          <p><b>Tipo de pago:</b> {{ payment.payment_type }}</p>
          <p><b>Referencia:</b> {{ payment.reference }}</p>

          <hr class="mt-4">

          <b-button
            variant="primary"
            class="mb-1 mt-4 btn-sm-block"
            :to="{ name: 'admin-orders'}"
          >
            Volver a pedidos
          </b-button>
        </div>
      </div>
    </div>
  </div>
  <loading-skeleton v-else />
</template>

<script>
/* eslint-disable global-require */
import {
  BLink, BFormInput, BButton, BForm, BImg, BBadge,
} from 'bootstrap-vue'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import api from '@/plugin/axios'
import { formatDate } from '@/helpers/utils'
import LoadingSkeleton from '@/views/misc/LoadingSkeleton.vue'

export default {
  components: {
    LoadingSkeleton,
    BLink,
    BFormInput,
    BButton,
    BForm,
    BImg,
    VuexyLogo,
    BBadge,
  },
  data() {
    return {
      transactionId: null,
      env: null,
      reference: null,
      transaction: null,
      planningOrder: null,
      alignerFabrication: null,
      payment: null,
    }
  },
  computed: {
    statusVariant() {
      const statusColor = {
        /* eslint-disable key-spacing */
        APPROVED      : 'success',
        DECLINED: 'warning',
        VOIDED   : 'info',
        ERROR  : 'error',
        /* eslint-enable key-spacing */
      }

      return status => statusColor[status]
    },
    statusName() {
      const statusLabel = {
        /* eslint-disable key-spacing */
        APPROVED      : 'Aprobado',
        DECLINED: 'Rechazada',
        VOIDED   : 'Anulada',
        ERROR  : 'Error',
      }

      return status => statusLabel[status]
    },
    formatDateVariant() {
      return date => formatDate(date)
    },

  },
  async created() {
    console.log('entra')
    this.reference = this.$route.params.reference
    this.transactionId = this.$route.query.id
    this.env = this.$route.query.env
    const [response] = await Promise.all([
      api.get(`/api/payments/wompi/status/${this.transactionId}/${this.reference}`),
    ])

    this.transaction = response.data.data_response
    this.payment = response.data.payment
    this.planningOrder = response.data.payment.planning_order
    this.alignerFabrication = response.data.payment.aligner_fabrication
    console.log(this.transaction, this.planningOrder, this.alignerFabrication)
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-misc.scss';
</style>
